export default "__VITE_ASSET__7x9LaxSn__"